




































import Base from "@/controllers/base.ts";
import { Component } from "vue-property-decorator";
import { Carousel } from "ant-design-vue";
import CTabs from "./cTabs.vue";

@Component({
  name: "MyApp",
  components: {
    CTabs,
    ACarousel: Carousel
  }
})
export default class MyApp extends Base {
  private carouselStep = 6;
  private total = 0;
  private dataSource: any[] = [];

  private created() {
    this.ssoConfigAllList();
  }

  private get myApp() {
    const step = this.carouselStep;
    const _return: any[] = Array.from({ length: Math.ceil(this.dataSource.length / step) }, () => []);
    for (let i = 0; i < _return.length; i++) {
      for (let j = i * step; j < i * step + step; j++) {
        if (this.dataSource[j]) {
          _return[i].push(this.dataSource[j]);
        } else {
          break;
        }
      }
    }
    return _return;
  }

  private async goSso(id: string) {
    const res = await this.$api.GetSsoUrl(id);
    if (res && res.code === 200) {
      if (res.data.URL) {
        this._goto(res.data.URL, res.data.openWay);
      } else {
        this.$message.error("跳转地址为空");
      }
    }
  }

  private async ssoConfigAllList() {
    const res = await this.$api.SsoConfigAllList();
    if (res && res.code === 200) {
      this.total = res.total;
      this.dataSource = res.rows;
    }
  }
}
